'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:LoginCtrl
 * @description
 * # RegisterCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('RegisterCtrl', ['$scope', '$location', 'Session', 'Discipline', 'Position', 'InstitutionService',
      function ($scope, $location, Session, Discipline, Position, InstitutionService) {

          $scope.errInvalidMsg = '';
          $scope.errPasswordMsg = '';
          $scope.userSubmitted = false;

      $scope.user = {
          username: $scope.email,
          password: $scope.password,
          email: $scope.email,
          discipline: '',
          institution: '',
          position: ''
      };

      Discipline.getDisciplines().then(function () {
          $scope.disciplines = Discipline.disciplines;
      });

      Position.getPositions().then(function () {
          $scope.positions = Position.positions;
      });

      $scope.Institution = {
          Loading: false,
          NoResults: false,
      };

      $scope.searchInstitution = function (text) {
          return InstitutionService.search(text).then(function (response) {
              return response.data;
          });
      };

    $scope.passwordFieldChange = function () {

        $scope.registerForm.confirmPassword.$setValidity('confirmPassword', $scope.registerForm.password.$modelValue === $scope.registerForm.confirmPassword.$modelValue);

        $scope.errPasswordMsg = '';
    };

    $scope.createUser = function () {

          $scope.userSubmitted = true;
          $scope.errInvalidMsg = '';
          if ($scope.registerForm.$invalid) {
              $scope.errInvalidMsg = 'Please fill all required fields and resolve any form errors.';
              return;
          }

          // This is mostly about mapping empty string to null so model binding works on the backend
          let createModel = {
              username: $scope.user.email,
              password: $scope.user.password,
              email: $scope.user.email,
              institution: $scope.user.institution,
              discipline: ($scope.user.discipline ? $scope.user.discipline : null),
              disciplineOther: ($scope.user.disciplineOther ? $scope.user.disciplineOther : null),
              position: ($scope.user.position ? $scope.user.position : null)
          };

          Session.createUser(createModel)
              .then(function (response) {

                  if (response.data.success) {
                      $location.url('/login');
                  } else {
                      // We're assuming the error is due to an issue with the password
                      $scope.errPasswordMsg = response.data.errors[0];
                  }
                
          }), function () {

              $scope.errInvalidMsg = 'Unable to create user.';
          };
      };

  }]);
